import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map } from 'immutable';

import Combination from './Combination.jsx';

class CombinationLists extends React.Component {
  static propTypes = {
    combinations: ImmutablePropTypes.list,
    multiples: ImmutablePropTypes.map,
    currency: ImmutablePropTypes.map,
    selectedSP: PropTypes.bool,
    legsIds: PropTypes.array,
    channel: PropTypes.string,
    allowFreeBet: PropTypes.bool,

    onMakeCombinationBet: PropTypes.func,
    onAddMultiple: PropTypes.func,
    onClearMultiple: PropTypes.func,
    onRemoveMultiple: PropTypes.func,
    bonusEngineFreeBets: PropTypes.array,
    selectedFreeBets: PropTypes.array,
    toggleFreeBet: PropTypes.func,
    clearFreeBetSelection: PropTypes.func,
    isBonusEngine: PropTypes.bool,
    userId: PropTypes.number,
  };

  static defaultProps = {
    combinations: List(),
    multiples: Map(),
    selectedSP: false,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      stakePerLine: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    let shouldClearMultiples = true;

    props.multiples.map((m) => {
      if (props.combinations.find((c) => m.get('type') === c.get('type'))) {
        shouldClearMultiples = false;
      }
    });

    if (
      !props.combinations.equals(this.props.combinations) &&
      shouldClearMultiples
    ) {
      this.props.onClearMultiple();
    }
  }

  addMultiple(combination) {
    const {
      onAddMultiple,
      legsIds,
      channel,
      allowFreeBet = false,
    } = this.props;

    if (!combination) {
      return null;
    }

    onAddMultiple(
      combination,
      legsIds,
      channel,
      allowFreeBet,
      this.props.selectedFreeBets,
    );
  }

  removeMultiple(combination) {
    const { onRemoveMultiple } = this.props;

    if (!combination) {
      return null;
    }

    onRemoveMultiple(combination.get('type'));
  }

  hasBlockerErrros(errors) {
    const BLOCKER_ERRORS = ['related', 'singles-only'];
    return (
      errors.filter((err) => BLOCKER_ERRORS.includes(err.get('code'))).size > 0
    );
  }

  render() {
    const {
      combinations,
      onAddMultiple,
      onRemoveMultiple,
      legsIds,
      multiples,
      ...restProps
    } = this.props;
    return (
      <ul>
        {combinations.map((combination) => {
          return (
            !this.hasBlockerErrros(combination.get('errors') || Map()) && (
              <Combination
                key={combination.get('type')}
                combination={combination}
                isEmpty={!multiples.size}
                potentialReturns={multiples.getIn([
                  combination.get('type'),
                  'potentialReturns',
                ])}
                errors={multiples.getIn([combination.get('type'), 'errors'])}
                onAddMultiple={this.addMultiple.bind(this)}
                onRemoveMultiple={this.removeMultiple.bind(this)}
                bonusEngineFreeBets={this.props.bonusEngineFreeBets.filter(
                  (freeBet) => freeBet.type === combination.get('type'),
                )}
                selectedFreeBets={this.props.selectedFreeBets.filter(
                  (selectedFreeBet) =>
                    selectedFreeBet.type === combination.get('type'),
                )}
                toggleFreeBet={this.props.toggleFreeBet}
                clearFreeBetSelection={this.props.clearFreeBetSelection}
                isBonusEngine={this.props.isBonusEngine}
                userId={this.props.userId}
                {...restProps}
              />
            )
          );
        })}
      </ul>
    );
  }
}

export default CombinationLists;
